/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Input.Gamepad
 */

module.exports = {

    Axis: require('./Axis'),
    Button: require('./Button'),
    Gamepad: require('./Gamepad'),
    GamepadPlugin: require('./GamepadPlugin'),
    
    Configs: require('./configs/')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/input/gamepad/index.js
// module id = 1830
// module chunks = 0